// extracted by mini-css-extract-plugin
export var standaloneTable = "_fe-0";
export var withExtraHeader = "_fe-1";